import { z } from 'zod';

export const FINDINGS_GROUP_PUBLISHED_KEY = {
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished',
} as const;

export const FINDINGS_GROUPED_LIST_LIMIT = 500;

export const FindingsGroupByFieldSchema = z.enum([
  'severity',
  'status',
  'category',
  'relatedEndpoint',
  'createdAt',
  'relatedSignal',
  'title',
  'isPublished',
  'targetName',
  'publishedAt',
  'linkedTicket',
  'discoveryDate',
  'classification',
  'cvss',
]);

export const FindingsGroupCountSchema = z.object({
  key: z.string(),
  count: z.number().int().nonnegative(),
});

export type FindingsGroupByField = z.infer<typeof FindingsGroupByFieldSchema>;
export type FindingsGroupCount = z.infer<typeof FindingsGroupCountSchema>;
